export const ZeroBytes32 = '0x0000000000000000000000000000000000000000000000000000000000000000';
export const BaseAssetId = ZeroBytes32;
export const EmptyRoot = '0xe3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';
